import i18next from 'i18next';

const translateConstant = (group, value) => {
  const key = `constants:${group}.${value}`;
  return i18next.exists(key) ? i18next.t(key) : value;
};

const formatValue = (filterName, value) => {
  if (typeof value === 'number') {
    return Number.isInteger(value) ? translateConstant(filterName, value) : value.toFixed(3);
  }

  if (typeof value === 'string') {
    return translateConstant(filterName, value);
  }

  if (Array.isArray(value)) {
    return value.map((v) => translateConstant(filterName, v)).join(', ');
  }

  if (typeof value === 'object') {
    if ('min' in value && 'max' in value) {
      return i18next.t('verifiers:threshold_value.range', { min: value.min, max: value.max });
    }
  }

  return String(value);
};

export const formatFilterReason = (filter) => {
  const { filter_name, object_value, threshold_value } = filter;
  const filterName = i18next.t(`verifiers:filter_name.${filter_name}`);
  const objectValue = formatValue(filter_name, object_value);
  const thresholdValue = formatValue(filter_name, threshold_value);

  return { filterName, objectValue, thresholdValue };
};
